/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `created` - created
 * * `skipped` - skipped
 * @export
 */
export const HoldDateOutcomeStatusEnum = {
    Created: 'created',
    Skipped: 'skipped'
} as const;
export type HoldDateOutcomeStatusEnum = typeof HoldDateOutcomeStatusEnum[keyof typeof HoldDateOutcomeStatusEnum];


export function instanceOfHoldDateOutcomeStatusEnum(value: any): boolean {
    for (const key in HoldDateOutcomeStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(HoldDateOutcomeStatusEnum, key)) {
            if (HoldDateOutcomeStatusEnum[key as keyof typeof HoldDateOutcomeStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HoldDateOutcomeStatusEnumFromJSON(json: any): HoldDateOutcomeStatusEnum {
    return HoldDateOutcomeStatusEnumFromJSONTyped(json, false);
}

export function HoldDateOutcomeStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldDateOutcomeStatusEnum {
    return json as HoldDateOutcomeStatusEnum;
}

export function HoldDateOutcomeStatusEnumToJSON(value?: HoldDateOutcomeStatusEnum | null): any {
    return value as any;
}

export function HoldDateOutcomeStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): HoldDateOutcomeStatusEnum {
    return value as HoldDateOutcomeStatusEnum;
}
